"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SCHEDULE_FOR_DELIVERY_MODAL = void 0;
var SCHEDULE_FOR_DELIVERY_MODAL = {
  INPUT__DELIVERY_DATE: 'scheduleForDeliveryModal-datePicker-deliveryDate',
  BUTTON__CONFIRM: 'scheduleForDeliveryModal-button-confirm',
  BUTTON__CANCEL: 'scheduleForDeliveryModal-button-cancel',
  BUTTON__WAREHOUSE: 'scheduleForDeliveryModal-button-warehouse',
  BUTTON__ADVANCED_OPTIONS: 'scheduleForDeliveryModal-button-advancedOptions',
  TEXTAREA__NOTE: 'ordersScheduleOrderModal-textarea-note',
  CONTAINER__ADVANCED_OPTIONS_CONTAINER: 'scheduleForDeliveryModal-div-advancedInventoryManagementContainer',
  TEXT__ADVANCED_OPTIONS_ERROR: 'scheduleForDeliveryModal-div-advancedInventoryManagementError'
};
exports.SCHEDULE_FOR_DELIVERY_MODAL = SCHEDULE_FOR_DELIVERY_MODAL;